import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import UploadImage from "../../components/UploadImage";
import ModelUtilitySpecsManager from "../../components/ModelUtilitySpecsManager";
import "../../styles/Edit.css";
import backendUrl from "../../BackendUrl";

const EditModel = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [modelData, setModelData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [initialUtility, setInitialUtility] = useState(false);
  const adminToken = localStorage.getItem("adminToken");

  useEffect(() => {
    const fetchModelData = async () => {
      try {
        const res = await axios.get(
          `${backendUrl}/api/vehicles/get-model/${id}`
        );

        setModelData({
          ...res.data,
          utility: res.data.utility ?? false,
          ready: res.data.ready ?? false,
          utilitySpecs: res.data.utilitySpecs || [],
        });
        setInitialUtility(res.data.utility ?? false);

        setLoading(false);
      } catch {
        setError("Failed to fetch model data.");
        setLoading(false);
      }
    };

    fetchModelData();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setModelData((prev) => ({ ...prev, [name]: value }));
  };

  const toggle = (field) => {
    setModelData((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
        `${backendUrl}/api/vehicles/update-model/${id}`,
        modelData,
        { headers: { Authorization: `Bearer ${adminToken}` } }
      );
      setModelData({
        ...response.data,
        utilitySpecs: response.data.utilitySpecs || [],
      });
      alert("Model updated successfully!");
    } catch (error) {
      console.error("Update failed:", error);
      alert("Failed to update model.");
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Delete this model?")) return;
    try {
      await axios.delete(
        `${backendUrl}/api/vehicles/delete-model/${id}`,
        { headers: { Authorization: `Bearer ${adminToken}` } }
      );
      navigate("/edit-website");
    } catch {
      alert("Failed to delete model.");
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="error">{error}</p>;

  return (
    <div className="edit-class-container">
      <div className="edit-form">
        <h2>Edit Model</h2>

        <form onSubmit={handleSubmit}>
          <label>
            Model Name:
            <input
              type="text"
              name="model"
              value={modelData?.model || ""}
              onChange={handleInputChange}
            />
          </label>

          <label>
            Description:
            <textarea
              name="description"
              value={modelData?.description || ""}
              onChange={handleInputChange}
              rows={4}
            />
          </label>

          {/* READY TOGGLE */}
          <label className="toggle">
            <input
              type="checkbox"
              name="ready"
              checked={modelData?.ready || false}
              onChange={(e) =>
                setModelData((prev) => ({
                  ...prev,
                  ready: e.target.checked,
                }))
              }
            />
            <span>Ready</span>
          </label>

          {/* UTILITY TOGGLE (Before SAVE) */}
          <label className="toggle" style={{ marginTop: "1rem" }}>
            <input
              type="checkbox"
              name="utility"
              checked={modelData?.utility || false}
              onChange={(e) =>
                setModelData((prev) => ({
                  ...prev,
                  utility: e.target.checked,
                  utilitySpecs: e.target.checked ? prev.utilitySpecs || [] : [],
                }))
              }
            />
            <span>Utility Vehicle</span>
          </label>

          {/* SAVE BUTTON */}
          <button type="submit">Save Changes</button>

          {/* UTILITY SPECS MANAGER (AFTER SAVE BUTTON) */}
          {initialUtility && (
            <>
              <h3 style={{ marginTop: "1rem" }}>Utility Specifications</h3>

              <ModelUtilitySpecsManager
                modelId={id}
                utilitySpecs={modelData.utilitySpecs || []}
                onUpdate={(updatedSpecs) =>
                  setModelData((prev) => ({
                    ...prev,
                    utilitySpecs: updatedSpecs,
                  }))
                }
              />
            </>
          )}
        </form>

        <UploadImage
          uploadUrl="/api/vehicles/upload-model"
          id={id}
        />

        <button
          type="button"
          onClick={handleDelete}
          style={{ background: "red", color: "white", marginTop: "1rem" }}
        >
          Delete Model
        </button>
      </div>

      <div className="display-section">
        {modelData.modelImg && (
          <div className="image-container">
            <img src={modelData.modelImg} alt="Model" />
            <div className="image-title">{modelData.model}</div>
          </div>
        )}
        <p className="description">{modelData.description}</p>
      </div>
    </div>
  );
};

export default EditModel;